import { useMutation, useQueryClient } from '@tanstack/react-query';

import { aiIncidentsApi } from '../api/aiIncidents';
import { aiIncidentsQueryKeys } from './queryKeys';

export const useDeleteAiIncident = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: aiIncidentsApi.deleteAiIncident,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: aiIncidentsQueryKeys.all });
    },
  });
};
